import React, { useEffect, useState, useRef } from "react";
import "../styles/Video.css";
import LosMurcielagos from "../img/thumbnail/Los_Murcielagos_NasDaily_Feliernst.jpg";
import JuanCarlos from "../img/thumbnail/JuanCarlosPallarols_NasDaily_Feliernst.jpg";
import reel from "../img/video/flxpntx_reel.mp4";

// Video data with thumbnails
const videosData = [
  {
    artist: "ESPONJABON",
    title: "Alazrraki",
    year: "",
    source: "https://www.youtube.com/embed/fh8lLGb1K5I",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "BREAK THE ROLES",
    title: "Open Government Partnership",
    year: "",
    source: "https://www.youtube.com/embed/EvZ8i0LA5Fs",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "He Turns Bullets Into Roses",
    title: "Nas Daily",
    year: "",
    source: "https://www.youtube.com/embed/vO5mlx8ZRno?si=tAEUblYw3MUTSSHw",
    type: "youtube",
    thumbnail: JuanCarlos,
  },
  {
    artist: "Blind Football Team Links",
    title: "Nas Daily",
    year: "",
    source: "https://www.youtube.com/embed/lrXJDSzNILo?si=VLnFq3rqABVYTR-m",
    type: "youtube",
    thumbnail: LosMurcielagos,
  },

  {
    artist: "TECHO",
    title: "Prójimo",
    year: "",
    source: "https://www.youtube.com/embed/IaY7JkKOkG0",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "BURGER KING",
    title: "Filmamo",
    year: "",
    source: "https://www.youtube.com/embed/oPOino_mXjs?si=d-VDr_6yuNXNHlWe",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "NIKE",
    title: "Prójimo",
    year: "",
    source: "https://www.youtube.com/embed/NVCwSjP6WFk",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "JUMEX",
    title: "Alazrraki",
    year: "",
    source: "https://www.youtube.com/embed/CpFj6Q30RwU",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "JUMEX",
    title: "Alazrraki",
    year: "",
    source: "https://www.youtube.com/embed/1oebX7D6hsA",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "JUMEX",
    title: "Alazrraki",
    year: "",
    source: "https://www.youtube.com/embed/8L0QTJ9QD3k?si=Rc5WPWzwNEycAMSK",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "KERMATO",
    title: "Alazrraki",
    year: "",
    source: "https://www.youtube.com/embed/19TL44uDRgE",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "KERMATO",
    title: "Alazrraki",
    year: "",
    source: "https://www.youtube.com/embed/K5svs60xFNQ ",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "Youth Olympics Games",
    title: "Prójimo",
    year: "",
    source: "https://www.youtube.com/embed/CfjITJfkQ-o?si=OA28Fi6OcW_mDFDh",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "The Human Safety Net",
    title: "GRUPO GENERALI & LA CAJA SEGUROS",
    year: "",
    source: "https://www.youtube.com/embed/YUnIKTjCKEo",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "BUENOS AIRES CIUDAD",
    title: "Prójimo",
    year: "",
    source: "https://www.youtube.com/embed/GYDsRdmN5zU",
    type: "youtube",
    thumbnail: "",
  },
  {
    artist: "REEL",
    source: reel,
    type: "video",
    thumbnail: "",
  },

];

const AddsVideo = () => {
  const [visibleVideos, setVisibleVideos] = useState(9); // Mostrar inicialmente 9 videos
  const [isPlaying, setIsPlaying] = useState({});
  const videoRefs = useRef([]); // Array de referencias para cada contenedor de video

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 100) {
        setVisibleVideos((prev) => Math.min(prev + 2, videosData.length));
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handlePlayVideo = (index) => {
    setIsPlaying((prev) => ({ ...prev, [index]: true }));
  };

  useEffect(() => {
    videoRefs.current.forEach((videoRef, index) => {
      if (videoRef) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add("appear");
                observer.unobserve(entry.target); // Detener la observación una vez visible
              }
            });
          },
          { threshold: 0.3 }
        );
        observer.observe(videoRef);
      }
    });
  }, [visibleVideos]); // Re-ejecutar cuando visibleVideos cambie

  return (
    <div className="video-page">
      {videosData.slice(0, visibleVideos).map((video, index) => (
        <div
          key={index}
          className="video-container"
          ref={(el) => (videoRefs.current[index] = el)} // Asigna una referencia única a cada contenedor
        >
          <h2 className="gallery-subtitle">
            <span className="agency-title">{video.artist}</span> {video.title}
          </h2>
          <div className="video-wrapper">
            {isPlaying[index] || !video.thumbnail ? (
              <iframe
                className="video"
                src={video.source}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
              ></iframe>
            ) : (
              <img
                src={video.thumbnail}
                alt={video.title}
                className="video-thumbnail"
                onClick={() => handlePlayVideo(index)}
              />
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AddsVideo;